import {
  setTicket,
  setToken,
  getToken,
  getTicket,
  setUserInfo,

} from "../utils/auth";
import getPublicKey from '@/api/sign';
import {getQueryString} from '../utils/index'
import store from "../store";
import {Message} from "portal-component";
import config from "@/config.js";
// 用来解码登录返回的 ticket
// debugger
let decodeTicket = async() =>  {
	// debugger
  if (location.href.indexOf("ticket=") != -1) {
    let url = decodeURIComponent(location.href);
    let ticketIndex = url.indexOf("ticket=");
    let routerIndex = url.indexOf("#/") !== -1 ? url.indexOf("#/") : url.length;
    if (ticketIndex !== -1) {
      let ticket = url.substring(ticketIndex + 7, routerIndex);
      let userInfo = JSON.parse(
        decodeURIComponent(escape(window.atob(ticket.split(".")[1])))
      );
     
      setTicket(ticket);
      setToken(userInfo.idToken);
      console.log('userInfo', userInfo)
      Cookies.set("isLogin", true);
      //setUserInfo(userInfo);
      window.location.href = process.env.VUE_APP_URL;
      return true;
    }
  }
  // console.log('location.href.indexOf("id_token")',location.href.indexOf("id_token"))
 
   // uniAuth 验证
   if(config.LOGIN_WAY === 'uniAuth' && location.href.indexOf("id_token") !== -1){
    let jsrsasign = require('jsrsasign');
    let ticket = getQueryString('id_token');
    console.log('ticket', ticket)
    setTicket(ticket);
    setToken(ticket)
    store.commit('SET_TOKEN',ticket)
    let secret;
    try{
      // 获取验签的key
      secret = await getPublicKey()
      console.log('secret',secret)
    }
    catch(err) {
      Message({
        message: '登陆验证失败！',
        type: "error",
        duration: 1000
      });
      let uniAuthConfig = JSON.parse(config.AUTH_SETTING);
      let url = `${uniAuthConfig.url}idtoken/logout?redirect_uri=${encodeURIComponent(process.env.VUE_APP_URL)}`;
      window.location.href = url;
      return false
    }
    let pubKey = jsrsasign.KEYUTIL.getKey(secret)
    let isValid = jsrsasign.KJUR.jws.JWS.verifyJWT(ticket, pubKey, {
      alg: ['RS512'],
      iss: ["uniauth"],
      aud: ["uniauth"]
    })

    if(!isValid) {
      // 验证不通过
      Message({
        message: '登陆验证失败！',
        type: "error",
        duration: 1000
      });
      let uniAuthConfig = JSON.parse(config.AUTH_SETTING);
      let url = `${uniAuthConfig.url}idtoken/logout?redirect_uri=${encodeURIComponent(process.env.VUE_APP_URL)}`;
      window.location.href = url;
      return false
    }
    let userInfo = jsrsasign.KJUR.jws.JWS.readSafeJSONString(jsrsasign.b64utoutf8(ticket.split(".")[1]));
    if(store.state.user.uniAuthNonce !== userInfo.nonce) {
      // 验证不通过
      Message({
        message: '登陆验证失败！',
        type: "error",
        duration: 1000
      });
      let uniAuthConfig = JSON.parse(config.AUTH_SETTING);
      let url = `${uniAuthConfig.url}idtoken/logout?redirect_uri=${encodeURIComponent(process.env.VUE_APP_URL)}`;
      window.location.href = url;
      return false;
    }
  }

}
export default decodeTicket